module.exports = __webpack_public_path__ + "img/tree-3.20f5b02b.png";